import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=b5a5ae32&scoped=true&"
import script from "./Suggest.vue?vue&type=script&lang=js&"
export * from "./Suggest.vue?vue&type=script&lang=js&"
import style0 from "./Suggest.vue?vue&type=style&index=0&id=b5a5ae32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a5ae32",
  null
  
)

export default component.exports